const WHATSAPP_NUMBER = "+918178052636";

export default function sendViaWhatsApp(formData) {
  const { name, phone, email, message } = formData;

  const text = `
  Hey there!

  I would like to book a **Laptop Home Service**. Here are my details:

  -----------------------------------------------

  - **Name**: ${name}
  - **Phone**: ${phone}
  - **Email**: ${email || 'N/A'}

  -----------------------------------------------

  **Issue with the Laptop**:
  ${message || 'Not sure about the exact issue, but I’m facing some problems with the laptop.'}

  -----------------------------------------------

  Can you arrange for someone to visit **within 1 hour**? Please let me know the earliest available slot!
`;

  const encodedText = encodeURIComponent(text);
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedText}`;

  try {
    const newWindow = window.open(whatsappUrl, "_blank");
    if (!newWindow) {
      alert("Unable to open WhatsApp. Please check your popup blocker.");
    }
  } catch (error) {
    console.error("WhatsApp launch failed:", error);
    alert("WhatsApp could not be opened. Please try calling us directly.");
  }


}

